import { connect } from 'react-redux';
import ReferAFriendShare from 'marketing/components/refer_a_friend_share';

const mapStateToProps = ({ user }) => {
  return {
    user: user.profile_data
  };
}

export default connect(mapStateToProps)(ReferAFriendShare);



// WEBPACK FOOTER //
// ./marketing/containers/refer_a_friend_share.js